module.exports = __webpack_public_path__ + "static/media/medical history.5084f100.svg";